import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import { bindActionCreators } from 'redux';
import Alert from '../../Components/Alert';
import { updateProfile } from '../../store/user/actions';
import { timers } from '../../config';

class EditProfile extends Component {
  state = {
    updated: false,
    name: this.props.user.name,
    email: this.props.user.email,
    old_pass: '',
    new_pass: '',
    showChangePass: false
  }

  handleFieldChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  toggleChangePass = () => {
    this.setState({showChangePass: !this.state.showChangePass})
  }

  updateProfile = (e) => {
    e && e.preventDefault();

    this.props.updateProfile({
      name: this.state.name,
      email: this.state.email,
      old_password: this.state.old_pass,
      new_password: this.state.new_pass,
    }, () => {
      this.setState({updated: true}, () => {
        setTimeout(() => {
          this.setState({updated: false});
        }, timers.alertHide);
      })
    });
  }

  render() {
    let color = 'red';
    let msg = this.props.user.error;

    if (this.state.updated) {
      color = 'green';
      msg = 'Profile updated successfully!';
    } else {
      color = 'red';
      msg = this.props.user.error;
    }

    return (
      <div className="wrapper">
        <Sidebar/>
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading">
              <h1>Edit Profile</h1>
            </div>
          </div>
          <hr/>
          <Alert color={color} msg={msg} />
          <form className="addAdminForm" onSubmit={this.updateProfile}>
            <div className="form-field">
              <h5 className="label">Full Name</h5>
              <input type="text" name="name" onChange={this.handleFieldChange} value={this.state.name} />
            </div>
            <div className="form-field">
              <h5 className="label">Email Address</h5>
              <input type="email" name="email" readOnly disabled onChange={this.handleFieldChange} value={this.state.email} />
            </div>
            <hr/>
            <a href="#!" type="button" style={{color: "#4A90E2", fontSize: "13px"}} onClick={this.toggleChangePass}>Change Password</a>
            {this.state.showChangePass 
              && (
                <>
                  <div className="form-field">
                    <h5 className="label">Old Password</h5>
                    <input type="password" name="old_pass" onChange={this.handleFieldChange} value={this.state.old_pass} />
                  </div>
                  <div className="form-field">
                    <h5 className="label">New Password</h5>
                    <input type="password" name="new_pass" onChange={this.handleFieldChange} value={this.state.new_pass} />
                  </div>
                </>
              )}
            <hr/>
            <Btn className="btn submit">Update</Btn>
          </form>
          
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  updateProfile: bindActionCreators(updateProfile, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditProfile));